import styled from 'styled-components';

import { flexEnd } from '../../../style/reusableStyle';

export const CreateProposalContainerStyled = styled.div`
  margin-top: 18px;
  padding-bottom: 80px;
  & .main-container {
    padding: 0px 20px;
  }

  & .form-container {
    max-width: 800px;
  }
`;

export const SplitInputContainerStyled = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;

  & div {
    flex: 1;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column;
  }
`;

export const CloseAdditionalWrapperStyled = styled.div`
  ${flexEnd(0)};

  & svg {
    cursor: pointer;
    path {
      stroke: red;
    }
  }
`;
